import { Components } from "@thisgorilla/primate-ds";
import { ListItemProps } from "@thisgorilla/primate-ds/dist/components/ListItem";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { API_CALLS } from "../../../../../API/api_calls";
import { useClickOutside } from "../../../../../hooks/useClickOutside";
import { useAppSelector } from "../../../../../redux";
import { ROUTES } from "../../../../../utills/routes";
import { DROPDOWN_OVER_MODAL_Z_INDEX } from "../../../../../utils";
import { FlexColumn } from "../../../../Common/Styles";
import DraftsModal from "./draftsModal";

const Manage = () => {
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isDraftModalOpen, setIsDraftModalOpen] = useState(false);
  const { draftArticle } = useAppSelector((state) => state.article);

  useClickOutside({ ref: containerRef, setState: setDropdownOpen });

  const onClick = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const onClickDraftModal = (index: number) => {
    setDropdownOpen(!isDropdownOpen);
    setIsDraftModalOpen(true);
    setSelectedTabIndex(index);
  };
  const menuLists: ListItemProps.IProps[] = [
    { type: "Label", label: "Manage article preferences" },
    {
      type: "List Item",
      label: "Preview",
      onClick: () => {
        setDropdownOpen(!isDropdownOpen);
        navigate(ROUTES.article + `/${draftArticle.post_id}`);
      },
    },
    {
      type: "List Item",
      label: "Duplicate as draft",
      onClick: () => {
        setDropdownOpen(!isDropdownOpen);
        API_CALLS.ARTICLE.duplicateAnArticleDraftAsANewDraft(
          draftArticle.post_id,
          navigate
        );
      },
    },
    {
      type: "List Item",
      label: "New draft",
      onClick: () => {
        window.location.href = ROUTES.article;
      },
    },
    {
      type: "List Item",
      label: "Drafts",
      onClick: () => {
        onClickDraftModal(0);
      },
    },
    {
      type: "List Item",
      label: "Scheduled",
      onClick: () => {
        onClickDraftModal(1);
      },
    },
    {
      type: "List Item",
      label: "Published",
      onClick: () => {
        onClickDraftModal(2);
      },
    },
  ];
  return (
    <RelativeContainer $isActive={isDropdownOpen}>
      <Components.Button
        size="Medium"
        kind="Secondary"
        color="Neutral"
        disabled={false}
        label="Manage"
        onClick={onClick}
        iconPosition="right"
        iconType="ChevronDown"
      />
      {isDropdownOpen && (
        <Container ref={containerRef}>
          <Components.Menu size="large" itemGap={8}>
            <FlexColumn $gapInPx={0}>
              {menuLists.slice(0, 4).map((item, index) => (
                <Components.ListItem {...item} key={index} />
              ))}
            </FlexColumn>
            <Components.ListItem type="Divider" />
            <FlexColumn $gapInPx={0}>
              {menuLists.slice(4).map((item, index) => (
                <Components.ListItem {...item} key={index} />
              ))}
            </FlexColumn>
          </Components.Menu>
        </Container>
      )}
      {isDraftModalOpen && (
        <DraftsModal
          setIsDraftModalOpen={setIsDraftModalOpen}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      )}
    </RelativeContainer>
  );
};

export default Manage;

const RelativeContainer = styled.div<{ $isActive: boolean }>`
  position: relative;
  & .container > button {
    background-color: ${({ $isActive, theme }) =>
      $isActive &&
      theme.Color.background.brand.subtler["default-active"].value};
    border-color: ${({ $isActive, theme }) =>
      $isActive && theme.Color.border["ui-border-emphasize-brand"].value};
  }
`;

const Container = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-13"].value}rem;
  left: 0;
  z-index: ${DROPDOWN_OVER_MODAL_Z_INDEX};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
